import type { RelativeAbsolutePosition } from '../../../types/pointer-events.js';
import { SELECTION_EDGE_THRESHOLD } from '../constants.js';
import { adjustPosition } from './adjust-position.js';
import { isPositionInBounds } from './is-position-in-bounds.js';

export const isPositionInSelectionEdge = (
  position: RelativeAbsolutePosition,
  edge: RelativeAbsolutePosition,
) => {
  const edgeBounds: [RelativeAbsolutePosition, RelativeAbsolutePosition] = [
    adjustPosition(edge, -SELECTION_EDGE_THRESHOLD),
    adjustPosition(edge, SELECTION_EDGE_THRESHOLD),
  ];

  return isPositionInBounds(position, edgeBounds);
};
